export const STRINGS_RU = {
  chattyUnlimited: "Chatty Unlimited",
  benefits: [
    "Безлимитные сообщения и аудио с Chatty",
    "Разборы твоих ошибок, переводы и оценка произношения",
    "Подписчики в 7.5 раз чаще повышают свой уровень английского",
    "Можно отписаться в любой момент",
  ],
  proBenefit: "Высший уровень искуственного интеллекта",
  proTooltip:
    "Pro версия работает на новейшем искуственном интеллекте для улучшенных диалогов, продвинутой персонализации, лучшего понимания контекста, более естественных ответов и расширенных возможностей обучения",
  saleEnds: "До конца скидок",
  subscriptionActive: "Ваша подписка активна",
  validUntil: "Действует до",
  subscriptionType: "Тип подписки",
  price: "Стоимость",
  autoRenewal: "Автопродление",
  autoRenewalDisabled: "Отключено",
  cancelSubscription: "Отменить подписку",
  cancelSubscriptionConfirm: "Вы уверены, что хотите отменить подписку?",
  confirm: "Да, отменить подписку",
  continue: "Продолжить",
  selectPaymentMethod: "Выберите способ оплаты",
  paymentRu: "🇷🇺 Российские карты",
  paymentWorld: "🌍 Международные карты",
  close: "Закрыть",
  preparingPayment: "Подготовка платежа",
  pleaseWait: "Пожалуйста, подождите...",
  errorMessage: "Произошла ошибка при загрузке данных",
  month: "месяц",
  year: "год",
  resubscribe: "Подписаться",
  yearly: "Годовая подписка",
  monthly: "Месячная подписка",
  recommended: "Рекомендуем",
  perYear: "в год",
  perMonth: "в месяц",
  perDay: "в день",
  moreOptions: "Все варианты",
  prePaymentCtaButton: "Посмотреть планы",
  joinOver: "Присоединяйтесь к более чем ",
  userCount: "тысячам",
  usersLearnChatty: " пользователей, которые уже учатся с Chatty!",
  headline1000Phrases: "Выучите 1000+ фраз",
  heroSubtitle: "в первые 7 дней с Chatty Unlimited",
  reviewsTitle: "Что говорят ученики Chatty",
  reviewHeader1: "IELTS speaking 8.0!!🤯 🎉",
  reviewerName1: "Аня К.",
  reviewText1:
    "Общалась всего 1 месяц с Chatty и сдала ielts speaking на 8.0! До этого всегда боялась говорить вслух и был барьер просто начать говорить. Большое спасибо за такое прекрасное приложение - всем очень советую! 💗",
  reviewHeader2: "Готов к загранице",
  reviewerName2: "Кирилл В.",
  reviewText2:
    "Готовлюсь к поездке в Лондон и благодаря Chatty чувствую себя намного увереннее. Персональный разбор ошибок помог найти слабые места. Теперь могу поддержать разговор намного увереннее!",
  reviewHeader3: "Подруга и психолог ❤️",
  reviewerName3: "Маша",
  reviewText3:
    "Chatty стала для меня не просто учителем, но и настоящей подругой. Могу обсудить любые темы, даже личные. Помогает не только с языком, но и с жизненными советами! 🫂",
  screenshotTitle: "Заговорите как носитель",
  realConversations: "Общайтесь на любую тему",
  practiceSubheader: "Отправляйте голосовые и получайте разбор ошибок",
  pronunciationCoach: "Разбор лично Ваших ошибок",
  soundNative:
    "Для каждого своего ответа получайте детальный разбор каждого правила",
  instantFeedback: "Звучите как носитель",
  learnMistakes: "Получайте разбор произношения всего ответа и отдельных слов",
  savedConversations: "Учите слова из разговора",
  reviewProgress: "Запоминайте слова из Ваших разговоров",
  personalSettings: "Настройте под себя",
  customizeExperience:
    "Выберите британский или американский акцент, скорость произношения и многое другое",
  learningModes: "С любимым персонажем",
  differentWaysToLearn:
    "Учите английский с Илоном Маском, личным психологом или своим персонажем",
  streakTracking: "Следите за прогрессом",
  stayConsistent:
    "Поддерживайте стрик и следите за количеством новых слов и правильных ответов",
  translation: "Детальный перевод",
  understandEverything:
    "Переведите весь ответ Chatty или детально изучите перевод каждого слова",
  achievements: "Получайте награды",
  trackProgress:
    "Зарабатывайте звездочки и участвуйте в розыгрышах реальных призов",
  advancedCurriculum: "Продвинутая программа обучения",
  mistakesLessons: "Уроки на основе ваших ошибок",
  vocabularyInterests: "Словарный запас по вашим интересам",
  situationalRoleplays: "Ситуационные ролевые игры",
  pronunciationCoaching: "Коучинг произношения",
  customLesson: "Создание индивидуальных уроков",
  progressReports: "Отчеты о прогрессе",
};

export const STRINGS_EN = {
  chattyUnlimited: "Chatty Unlimited",
  benefits: [
    "Unlimited messages and audio with Chatty",
    "Explanation of your mistakes, translations, and pronunciation evaluation",
    "Subscribers level up their English 7.5x more often!",
    "Cancel anytime",
  ],
  proBenefit: "Most advanced artificial intelligence",
  proTooltip:
    "Pro version is powered by latest AI models for superior conversations, advanced personalization, better understanding of context, more natural responses, and enhanced learning capabilities",
  saleEnds: "Sale ends in",
  subscriptionActive: "Your subscription is active",
  validUntil: "Valid until",
  subscriptionType: "Subscription type",
  price: "Price",
  autoRenewal: "Auto-renewal",
  autoRenewalDisabled: "Disabled",
  cancelSubscription: "Cancel subscription",
  cancelSubscriptionConfirm:
    "Are you sure you want to cancel your subscription?",
  confirm: "Yes, cancel subscription",
  continue: "Continue",
  selectPaymentMethod: "Select payment method",
  paymentRu: "🇷🇺 Russian cards",
  paymentWorld: "🌍 International cards",
  close: "Close",
  preparingPayment: "Preparing payment",
  pleaseWait: "Please wait...",
  errorMessage: "Error loading data",
  month: "month",
  year: "year",
  resubscribe: "Subscribe",
  yearly: "Annual subscription",
  monthly: "Monthly subscription",
  recommended: "Recommended",
  perYear: "per year",
  perMonth: "per month",
  perDay: "per day",
  moreOptions: "More options",
  prePaymentCtaButton: "Check out plans",
  joinOver: "Join over ",
  userCount: "thousand",
  usersLearnChatty: " users who already learn with Chatty!",
  headline1000Phrases: "Speak 1,000+ phrases",
  heroSubtitle: "in the first 7 days with Chatty Unlimited",
  reviewsTitle: "What Chatty learners say",
  reviewHeader1: "IELTS speaking 8.0!!🤯 🎉",
  reviewerName1: "Anna K.",
  reviewText1:
    "I talked with Chatty for just 1 month and got 8.0 on IELTS speaking! Before I was always afraid to speak out loud and had a barrier to start speaking. Thank you for such a wonderful app - I highly recommend it to everyone! 💗",
  reviewHeader2: "Ready for abroad",
  reviewerName2: "Kirill B.",
  reviewText2:
    "Preparing for a trip to London and thanks to Chatty I feel much more confident. Personal error analysis helped find weak spots. Now I can maintain conversation much more confidently!",
  reviewHeader3: "Friend and psychologist ❤️",
  reviewerName3: "Masha",
  reviewText3:
    "Chatty became not just a teacher for me, but a real friend. I can discuss any topics, even personal ones. Helps not only with language, but also with life advice! 🫂",
  screenshotTitle: "Speak like a native",
  realConversations: "Talk about anything",
  practiceSubheader: "Send voice messages and get error analysis",
  pronunciationCoach: "Analysis of your personal mistakes",
  soundNative: "Get detailed breakdown of each rule for every answer",
  instantFeedback: "Sound like a native",
  learnMistakes:
    "Get pronunciation analysis of your entire response and individual words",
  savedConversations: "Learn words from conversation",
  reviewProgress: "Remember words from your conversations",
  personalSettings: "Customize for yourself",
  customizeExperience:
    "Choose British or American accent, pronunciation speed and more",
  learningModes: "With your favorite character",
  differentWaysToLearn:
    "Learn English with Elon Musk, personal psychologist or your own character",
  streakTracking: "Track your progress",
  stayConsistent:
    "Maintain streak and track number of new words and correct answers",
  translation: "Detailed translation",
  understandEverything:
    "Translate Chatty's entire response or study detailed translation of each word",
  achievements: "Get rewards",
  trackProgress: "Earn stars and participate in real prize giveaways",
  advancedCurriculum: "Advanced curriculum",
  mistakesLessons: "Lessons based on your mistakes",
  vocabularyInterests: "Vocabulary for your interests",
  situationalRoleplays: "Situational roleplays",
  pronunciationCoaching: "Pronunciation coaching",
  customLesson: "Custom lesson creation",
  progressReports: "Progress reports",
};
